<template>
<div class="seal pb120">
  <div class="top">
    <div v-if="honor == 0" class="box app-seal app-seal0">
      <div class="left">
        <p>普通印章</p>
        <router-link :to="{name:'rentsrecharge'}" class="btn btn0">选择印章</router-link>
      </div>
      <div class="right"></div>
    </div>
    <div v-else class="box app-seal" :class="['app-seal'+honor.id]">
      <div class="left">
        <p>{{honor.title}}</p>
        <div @click="rentsreturn" class="btn">租金退回</div>
      </div>
      <div class="right"></div>
      <span class="discount">{{honor.discount/10}}折</span>
    </div>
  </div>
  <div class="con topline">
      <div class="app-bigtit bottomline">{{pageinfo.title}}</div>
      <div class="app-text bottomline" v-html="pageinfo.content"></div>
  </div>
</div>
</template>

<script>
export default {
  data(){
    return{
      honor:0,
      honorInfo:[],
      pageinfo:''
    }
  },
  mounted() {
      this.getHonorInfo();
      this.getPage();
  },
  methods:{
    rentsreturn(){
      let vm = this;
      vm.ajax("account/honor/back", "post", {}, e => {
        vm.$router.push({ name: 'rentsreturn', query: { deposit: vm.honor.deposit } })
      })
    },
    getHonorInfo(){
      let vm = this;
      vm.ajax("account/honor", "get", '', e => {
        vm.honorInfo = e.data.list;
        vm.honorInfo.map((v,k)=>{
          if(v.id == e.data.honor){
            vm.honor = v;
          }
        })
      })
    },
    getPage(){
      let vm = this;
      vm.ajax("page", "get", 'id=3', e => {
        vm.pageinfo = e.data
        // vm.txt = e.data.content
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/seal.vue